"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFileField = void 0;
const form_field_1 = require("./form-field");
const file_field_1 = require("../../../components/file-field/file-field");
exports.FormFileField = form_field_1.formFieldFactory(file_field_1.FileField);
//# sourceMappingURL=form-file-field.js.map